import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-bold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cta focus-visible:ring-offset-2 focus-visible:ring-offset-surface disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-cta text-white hover:bg-cta-light shadow-sm",
        destructive: "bg-red-600 text-white hover:bg-red-700",
        outline: "border border-white/10 bg-transparent text-ink hover:bg-surface-2 hover:text-ink",
        secondary: "bg-surface-2 text-ink hover:bg-surface-3",
        ghost: "text-ink-dim hover:bg-surface-2 hover:text-ink",
        link: "text-cta underline-offset-4 hover:underline",
        primary: "bg-primary-500 text-primary-foreground hover:bg-primary-600 shadow-sm",
        success: "bg-cta text-white hover:bg-cta-light shadow-sm",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs font-medium",
        lg: "h-12 rounded-lg px-8 text-base font-bold",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }
